import { REQUIRED_MESSAGE, requiredString } from '@wyz/utils';
import { z } from 'zod';
import { associatedCriteriaSchema } from '~/common/schemas';
const INVALID_END_DATE_MESSAGE = 'app.common.validations.end_date_lower_start';

export const baseAdvert = z.object({
  id: z.string(),
  title: requiredString,
  summary: z.string(),
  endDate: z.date().nullish(),
  startDate: z.date().nullish(),
  criteria: z.array(associatedCriteriaSchema),
  languageIsoCode: requiredString,
  applyToAllCustomersChildren: z.boolean().nullish(),
  customerScope: z
    .array(
      z.object({
        id: requiredString,
      }),
    )
    .min(1, REQUIRED_MESSAGE),
});

export const advertPayload = baseAdvert
  .omit({
    id: true,
    startDate: true,
    endDate: true,
  })
  .extend({ endDate: z.string().nullish(), startDate: z.string().nullish() });

export const advertForm = baseAdvert
  .omit({
    id: true,
    criteria: true,
    customerScope: true,
  })
  .extend({
    criteria: z
      .array(
        z.object({
          criterion: z.object({ id: z.string() }),
          values: z.array(requiredString).min(1, { message: REQUIRED_MESSAGE }),
        }),
      )
      .min(1, { message: REQUIRED_MESSAGE }),
    customerScope: z.array(z.string()).min(1, REQUIRED_MESSAGE),
  })
  .superRefine((formData, ctx) => {
    // Conditional validation
    if (
      formData.startDate &&
      formData.endDate &&
      formData.startDate > formData.endDate
    ) {
      ctx.addIssue({
        code: 'custom',
        message: INVALID_END_DATE_MESSAGE,
        path: ['endDate'],
        fatal: true,
      });
    }
  });
